const forgetPasswordEndpointParamsSchema = (email, redirect_url) => ({
  email,
  redirect_url,
});

export default forgetPasswordEndpointParamsSchema;
